import axios from 'axios';

const API_URL = '/api/auth/';

class AuthService {
  async login(username, password) {
    const response = await axios.post(API_URL + 'login/', {
      username,
      password
    });
    if (response.data.access) {
      localStorage.setItem('user', JSON.stringify(response.data));
    }
    return response.data;
  }

  logout() {
    const user = this.getCurrentUser();
    if (user && user.access) {
      axios.post(API_URL + 'logout/', {}, {
        headers: this.authHeader()
      }).catch(() => {
        // Ignore errors on logout
      });
    }
    localStorage.removeItem('user');
    // Clear JWT and session cookies so stale tokens can't cause 401 loops
    ['auth-token', 'refresh-token', 'sessionid', 'csrftoken'].forEach(name => {
      document.cookie = `${name}=; Max-Age=0; path=/`;
    });
  }

  async register(username, email, password1, password2) {
    return axios.post(API_URL + 'registration/', {
      username,
      email,
      password1,
      password2
    });
  }

  getCurrentUser() {
    const userStr = localStorage.getItem('user');
    if (userStr) return JSON.parse(userStr);
    return null;
  }

  authHeader() {
    const user = this.getCurrentUser();
    if (user && user.access) {
      return { Authorization: 'Bearer ' + user.access };
    }
    return {};
  }

  isAuthenticated() {
    const user = this.getCurrentUser();
    return !!(user && user.access);
  }

  async getUserInfo() {
    const response = await axios.get('/api/user/', {
      headers: this.authHeader()
    });
    return response.data;
  }

  async updateProfile(data) {
    const response = await axios.patch('/api/user/', data, {
      headers: this.authHeader()
    });
    return response.data;
  }

  async changePassword(oldPassword, newPassword1, newPassword2) {
    const response = await axios.post(
      '/api/auth/password/change/',
      { old_password: oldPassword, new_password1: newPassword1, new_password2: newPassword2 },
      { headers: this.authHeader() }
    );
    return response.data;
  }

  async eidStart(method, data) {
    const response = await axios.post(API_URL + 'eid/start/', { method, ...data });
    return response;
  }

  async eidPoll(method) {
    const response = await axios.post(API_URL + 'eid/poll/', { method });
    return response;
  }

  eidLogin(data) {
    localStorage.setItem('user', JSON.stringify(data));
  }
}

const authService = new AuthService();
export default authService;
